import { Box, CircularProgress, Typography } from "@mui/material";
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Fetch from "../../services/Fetch";
import GridMediaCard from "../../components/cards/GridMediaCard";
import PageHero from "../../components/motion/PageHero";
import ScrollReveal from "../../components/motion/ScrollReveal";
import { resolveCourseImage } from "../../helper/resolveMediaUrl";
import { useConstants } from "../../hooks/UseConstants";

function Paths() {
    const host = `${process.env.REACT_APP_LOCAL_HOST}`;
    const { language } = useConstants();
    const isAr = language === 'ar';
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [paths, setPaths] = useState([]);

    useEffect(() => {
        const load = async () => {
            const result = await Fetch(`${host}/paths?per_page=30`, 'GET');
            if (result.status === 200) setPaths(result.data.data || []);
            setLoading(false);
        };
        load();
    }, [host]);

    if (loading) return <Box className="flex justify-center py-20"><CircularProgress size={70} /></Box>;

    return (
        <Box>
            <PageHero
                title={isAr ? 'المسارات التعليمية' : 'Learning paths'}
                subtitle={isAr ? 'مسارات متكاملة تجمع عدة دورات في رحلة واحدة' : 'Structured journeys combining multiple courses'}
                icon={<AccountTreeOutlinedIcon />}
            />
            {paths.length === 0 ? (
                <Typography color="text.secondary">{isAr ? 'لا توجد مسارات متاحة حالياً' : 'No paths available yet'}</Typography>
            ) : (
                <Box className="grid grid-cols-3 gap-5 max-sm:grid-cols-1 justify-items-center">
                    {paths.map((path, i) => (
                        <ScrollReveal key={path.id} delay={i * 60} direction="up" className="w-full">
                            <GridMediaCard
                                image={resolveCourseImage(path)}
                                title={path.name_ar || path.name_en}
                                description={path.description_ar || path.description_en}
                                onClick={() => navigate(`/paths/${path.id}`)}
                                footer={
                                    <Box>
                                        <Typography variant="caption" className="text-blue-600 font-bold">
                                            {path.effective_price ?? path.price} {isAr ? 'ر.س' : 'SAR'}
                                        </Typography>
                                        {path.has_active_discount ? (
                                            <Typography variant="caption" color="text.secondary" display="block" sx={{ textDecoration: 'line-through' }}>
                                                {path.price} {isAr ? 'ر.س' : 'SAR'}
                                            </Typography>
                                        ) : null}
                                    </Box>
                                }
                            />
                        </ScrollReveal>
                    ))}
                </Box>
            )}
        </Box>
    );
}

export default Paths;
